module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7r9n3n-c6f9adcb8ebef40fff77b688f589ee00.svg";